import { useReveal } from "../lib/useReveal";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
    {
        name: "Marcus T.",
        tag: "142 days sober",
        quote:
            "Hope doesn't judge the 3 AM thoughts. Just talking it out — even to an AI — got me to the morning meeting. That alone has been worth more than any app I've tried.",
        image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=300&q=80",
    },
    {
        name: "Priya M.",
        tag: "1 year sober",
        quote:
            "My journal stays on my phone. My story stays mine. That's the first recovery tool that felt like it was built for someone in my shoes — not for my insurance company.",
        image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=300&q=80",
    },
    {
        name: "Jay R.",
        tag: "Peer mentor, 7 years",
        quote:
            "I needed something between meetings. The daily check-in became my anchor — two minutes and I know where my head is. I recommend Hope to everyone I sponsor now.",
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=300&q=80",
    },
];

export default function Testimonials() {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            id="stories"
            data-testid="testimonials-section"
            className="py-20 md:py-24 bg-background border-b"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto mb-14 reveal">
                    <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-tight">
                        Loved by people actually in recovery
                    </h2>
                    <p className="text-lg text-muted-foreground">
                        Shared with permission. Names and photos may be changed to protect privacy —
                        because privacy is the whole point.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-6 reveal">
                    {TESTIMONIALS.map((t, i) => (
                        <figure
                            key={t.name}
                            data-testid={`testimonial-${i}`}
                            className="bg-card border rounded-2xl p-7 hover:shadow-lg hover:border-primary/40 transition-all flex flex-col"
                        >
                            <div className="flex items-center gap-0.5 text-amber-500 mb-4">
                                {Array.from({ length: 5 }).map((_, s) => (
                                    <Star key={s} size={14} fill="currentColor" />
                                ))}
                            </div>
                            <Quote className="w-6 h-6 text-primary/30 mb-3" />
                            <blockquote className="text-foreground leading-relaxed flex-1">
                                &ldquo;{t.quote}&rdquo;
                            </blockquote>
                            <figcaption className="mt-6 flex items-center gap-3 pt-5 border-t">
                                <img
                                    src={t.image}
                                    alt=""
                                    className="w-10 h-10 rounded-full object-cover"
                                />
                                <div className="leading-tight">
                                    <div className="font-semibold text-foreground text-sm">{t.name}</div>
                                    <div className="text-xs text-muted-foreground">{t.tag}</div>
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
